import React from 'react';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/CbseMandatoryDisclosure.css';

const sections = [
  {
    heading: 'A. General Information',
    rows: [
      ['Name of the School', 'Akash Model Sr. Sec. School'],
      ['Affiliation No.', '2730475'],
      ['School Code', '85369'],
      ['Complete Address with Pin Code', 'Baljeet Vihar, Nithari Extn. Near Rohini Sec-22, New Delhi-110086'],
      ['Principal Name & Qualification', 'Geeta Rani, M.A., B.Ed.'],
      ['School Email Id', 'akashschoolrana@gmail.com'],
      ['Contact Details', '9811088324'],
    ],
  },
  {
    heading: 'B. Documents & Information',
    rows: [
      ['Copies of Affiliation/Upgradation letter', '/CBSEMandatoryDocs/AFFILIATION_LETTER.pdf'],
      ['Copies of Societies/Trust/Company Registration/Renewal Certificate', '/CBSEMandatoryDocs/society_certificate.pdf'],
      ['Copy of No Objection Certificate (NOC)', '/CBSEMandatoryDocs/DEO_NOC.pdf'],
      ['Copies of Recognition Certificate', '/CBSEMandatoryDocs/recognition_letter.pdf'],
      ['Copy of valid Building Safety Certificate', '/CBSEMandatoryDocs/structure_stability_certificate.pdf'],
      ['Copy of valid Fire Safety Certificate', '/CBSEMandatoryDocs/FIRE_NOC.pdf'],
      ['Copy of the DEO Certificate', '/CBSEMandatoryDocs/DEO_NOC.pdf'],
      ['Copies of valid Water, Health and Sanitation Certificates', '/CBSEMandatoryDocs/school_health_certificate.pdf'],
    ],
  },
  {
    heading: 'C. Result and Academics',
    rows: [
      ['Fee Structure of the School', '/CBSEMandatoryDocs/FEE STRUCTURE.pdf'],
      ['Annual Academic Calendar', '/CBSEMandatoryDocs/ACADMIC_CALANDER.pdf'],
      ['List of School Management Committee (SMC)', '/CBSEMandatoryDocs/MANAGEMENT_COMMITTEE LIST.pdf'],
      ['List of Parents Teachers Association (PTA) Members', '/CBSEMandatoryDocs/PTA_MEMBER_LIST.pdf'],
      ['Last three-year Result of the Board Examination', ''],
    ],
  },
  {
    heading: 'D. Staff (Teaching)',
    rows: [
      ['Principal', 'Geeta Rani'],
      ['Total No. of Teachers', '96'],
      ['PGTs', '16'],
      ['TGTs', '38'],
      ['PRTs', '35'],
      ['Teachers Section Ratio', '1:1.5'],
      ['Details of Special Educator', '2'],
      ['Details of Counsellor and Wellness Teacher', '2'],
    ],
  },
  {
    heading: 'E. School Infrastructure',
    rows: [
      ['Total Campus Area of the School (in Sq. Mtr.)', '4048'],
      ['No. and Size of the Class Rooms (in Sq. Mtr.)', '53 & 47'],
      ['No. and Size of Laboratories including Computer Labs (in Sq. Mtr.)', '7 & 80'],
      ['Internet Facility', 'Yes'],
      ['No. of Girls Toilets', '15'],
      ['No. of Boys Toilets', '15'],
      ['Link of YouTube Video of the Inspection of School covering the Infrastructure', 'https://www.youtube.com/watch?v=fz33kKPThrU'],
    ],
  },
];

export default function CbseMandatoryDisclosure() {
  return (
    <Layout bannerTitle="CBSE Mandatory Disclosure">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="CBSE Mandatory Public Disclosure" />
          <div className="cbse-disclosure-wrapper mt-4">
            <div className="cbse-notice-box mb-4">
              <i className="fas fa-info-circle me-2"></i>
              As per CBSE Affiliation Bye-Laws, the following information is mandatory to be disclosed on the school website.
            </div>
            {sections.map((sec, si) => (
              <div key={si} className="cbse-section mb-4">
                <h5 className="cbse-section-heading">{sec.heading}</h5>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th style={{ width: '40%' }}>Information</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sec.rows.map(([label, value], ri) => (
                        <tr key={ri}>
                          <td className="disclosure-label">{label}</td>
                          <td>
                            {typeof value === 'string' && (value.startsWith('http') || value.startsWith('/')) ? (
                              <a href={value} target="_blank" rel="noopener noreferrer">
                                {value.includes('youtube.com') || value.includes('youtu.be') ? 'Click to Watch Video' : 'View Document'}
                              </a>
                            ) : value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
